var _rect, _path, _path2, _rect2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    rx: 2,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9863 11.8628C7.34714 12.0457 5.65285 12.0457 4.01372 11.8628C3.39831 11.7942 2.85803 11.4619 2.51629 10.9793L6.76544 6.73713L8.07657 8.04609C8.23206 8.20134 8.48417 8.20134 8.63966 8.04609C8.79515 7.89085 8.79515 7.63919 8.63966 7.48394L7.04697 5.89384C6.89147 5.7386 6.63941 5.7386 6.48391 5.89384L2.17546 10.1953C2.16357 10.1372 2.15401 10.0782 2.147 10.0185C1.951 8.34519 1.951 6.65481 2.147 4.98155C2.26109 4.00788 3.0441 3.24538 4.01372 3.13715C5.65285 2.95429 7.34714 2.95429 8.9863 3.13715C9.95591 3.24538 10.7389 4.00788 10.853 4.98155C11.049 6.65481 11.049 8.34519 10.853 10.0185C10.7389 10.9921 9.95591 11.7546 8.9863 11.8628Z",
    fill: "#B51D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8628 5.0137C11.0457 6.65286 11.0457 8.34715 10.8628 9.98628C10.7942 10.6017 10.4619 11.142 9.97935 11.4837L5.73712 7.23456L7.04609 5.92343C7.20134 5.76794 7.20134 5.51583 7.04609 5.36034C6.89085 5.20485 6.63919 5.20485 6.48394 5.36034L4.89384 6.95303C4.7386 7.10853 4.7386 7.36059 4.89384 7.51609L9.19527 11.8245C9.13719 11.8364 9.07822 11.846 9.01845 11.853C7.34519 12.049 5.65481 12.049 3.98155 11.853C3.00788 11.7389 2.24538 10.9559 2.13715 9.98628C1.95428 8.34715 1.95428 6.65286 2.13715 5.0137C2.24538 4.04409 3.00788 3.26108 3.98155 3.14702C5.65481 2.95099 7.34519 2.95099 9.01845 3.14702C9.9921 3.26108 10.7546 4.04409 10.8628 5.0137Z",
    fill: "#B51D1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 6,
    height: 5,
    fill: "#B51D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 9.47645L8.4784 5.13086",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 5.13086L8.4784 9.47644",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.562d3ce3921d1c2ed57495d3a87de8d2.svg";
export { ForwardRef as ReactComponent };